// @avantia common-code
import { setLoggerForClientAndServerUtilitiesPackage } from '@avantia/client-and-server-utilities';
import { setLoggerForFormValidationPackage } from '@avantia/form-validation';
import { createBrowserConsoleLogger } from '@avantia/logging-and-errors';
import { setLoggerForQuestionSetModelPackage } from '@avantia/questionset-model';
import {
  HpClaimsDebugFlags,
  logInfo,
  setLoggerFlagsForQuestionSetWebsite,
  setLoggerForQuestionSetWebsite
} from '../clientLogging';
import { setLoggerFlagsForEngineClient, setLoggerForEngineClient } from '../engineClient/clientLogging';
import { getConfig as getSpecificConfig } from './configuration.Octopus';
import { HpClaimsClientConfiguration } from './configurationTypes';

let cfg: HpClaimsClientConfiguration | undefined = undefined;
const isClientMode = !process.env || !process.env.npm_lifecycle_script;

export function getConfig(): HpClaimsClientConfiguration {
  if (cfg) {
    return cfg;
  }

  const config = Object.freeze(getSpecificConfig());
  cfg = config;

  const logger = createBrowserConsoleLogger();
  setLoggerForQuestionSetWebsite(logger);
  setLoggerFlagsForQuestionSetWebsite(config.claimsDebugFlags);

  setLoggerForEngineClient(logger);
  setLoggerFlagsForEngineClient(config.clientDebugFlags);

  setLoggerForClientAndServerUtilitiesPackage(logger);
  setLoggerForFormValidationPackage(logger);
  setLoggerForQuestionSetModelPackage(logger);

  if (isClientMode) {
    logInfo(config as any, HpClaimsDebugFlags.Configuration);
  }

  return config;
}
